import React from 'react'

interface ToggleProps {
    checked: boolean
    onChange: (checked: boolean) => void
    disabled?: boolean
    id?: string
    label?: string
}

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, id = 'toggle', label, disabled }) => {
    return (
        <label
            htmlFor={id}
            className={`flex items-center ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
            <div className='relative w-12 h-7'>
                <input
                    id={id}
                    type='checkbox'
                    className='sr-only peer'
                    disabled={disabled}
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <div className='w-full h-full bg-gray-300 rounded-full peer-checked:bg-[--tb-green] transition-colors duration-300'></div>
                <div className='absolute top-1 left-1 w-5 h-5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5' />
            </div>
            {label && <span className='ml-3 font-semibold text-lg text-[--tb-mainHeading]'>{label}</span>}
        </label>
    )
}

export default Toggle
